import { Injectable, signal } from '@angular/core';
import { ISidebarGroup } from '../interfaces/app.interface';

@Injectable({
  providedIn: 'root',
})
export class AppStore {
  public readonly sidebarGroups = signal<ISidebarGroup[]>([]);

  public setSidebarGroups(groups: ISidebarGroup[]): void {
    this.sidebarGroups.set(groups);
  }

  public clearSidebarGroups(): void {
    this.sidebarGroups.set([]);
  }
}
